import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PaymentScenarionActionMethodEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.action.method.enum';
import { PaymentScenarionActionMethodEnumI18n } from '@zaoblako/shared/modules/task/i18n/payment-scenarion-action-method.enum.i18n';

@Pipe({
  name: 'paymentTaskScenarioMethodName',
  standalone: true
})
export class PaymentTaskScenarioMethodNamePipe implements PipeTransform {
  public transform(kind: PaymentScenarionActionMethodEnum): string {
    return PaymentScenarionActionMethodEnumI18n[I18nLocalesEnum.RU_RU][kind] || '';
  }
}
